import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto" }
const _hoisted_2 = { class: "trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_3 = { class: "trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md" }
const _hoisted_4 = { class: "trezo-card-subtitle" }
const _hoisted_5 = { class: "trezo-card-footer flex items-center justify-between -mx-[20px] md:-mx-[25px] px-[20px] md:px-[25px] pt-[20px] md:pt-[25px] border-t border-gray-100 dark:border-[#172036]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]',
      { active: _ctx.stateStoreInstance.active },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Modal Title")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
            ]))
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "trezo-card-content pb-[20px] md:pb-[25px]" }, ".....", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "inline-block py-[10px] px-[30px] bg-danger-500 text-white transition-all hover:bg-danger-400 rounded-md border border-danger-500 hover:border-danger-400",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
          }, " Close "),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            class: "inline-block py-[10px] px-[30px] bg-primary-500 text-white transition-all hover:bg-primary-400 rounded-md border border-primary-500 hover:border-primary-400 ltr:mr-[11px] rtl:ml-[11px] mb-[15px]",
            type: "button"
          }, " Save Changes ", -1))
        ])
      ])
    ])
  ], 2))
}